<template>
  <div>
    <div class="panel-heading d-flex align-center py-2">
      <h4 class="panel-title">
        {{ $t('sendNotification.title') }}
      </h4>
    </div>

    <div class="panel-body">
      <div class="row">
        <!-- customersList -->
        <div class="col-12 col-md-6 px-4">
          <div class="row">
            <div class="col-md-4">
                <v-checkbox
                v-model="form.addall"
                :label="$t('sendNotification.sendToAllLabel')"
                color="success"
                :disabled="customersList.length === 0 || form.delivered_only"
                dense
                />
                <v-checkbox
                v-model="form.delivered_only"
                :label="$t('sendNotification.sendToDeliveredLabel')"
                color="success"
                :disabled="form.addall"
                dense
                />
            </div>
            <div class="col-md-8">
              <v-select
                v-if="showSearch"
                v-model="customer"
                autocomplete
                :items="customersList"
                item-value="value"
                :label="$t('sendNotification.selectCustomerLabel')"
                return-object
                clearable
                single-line
                @input="customerSelected()"
              />

              <v-text-field
                v-else
                :label="$t('columns.customer')"
              />
            </div>

            <div class="col-12">
              <table class="table table-framed">
                <thead>
                  <tr>
                    <th style="width: 50px">#</th>
                    <th>{{ $t('columns.name') }}</th>
                    <th>{{ $t('columns.phoneNumber') }}</th>
                    <th style="width: 50px" />
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(customer, index) in selectedCustomers"
                    :key="index"
                  >
                    <td>{{ index +1 }}</td>
                    <td>{{ customer.full_name }}</td>
                    <td>{{ customer.phone_number }}</td>
                    <td>
                      <div
                        @click="removeCustomer(index)"
                        style="cursor: pointer;"
                      >
                        <i
                          style="font-size: 20px; color: red"
                          class="fa fa-close"
                        ></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- title & body -->
        <div class="col-12 col-md-6 px-4">
          <div class="row">
            <div class="col-12">
              <v-text-field
                v-model="form.title"
                :label="$t('columns.title')"
              />
            </div>

            <div class="col-12">
              <v-text-field
                v-model="form.body"
                :label="$t('sendNotification.bodyLabel')"
              />
            </div>

            <div class="col-12">
              <v-btn
                @click="submit()"
                style="height: auto;"
                depressed
                color="primary"
                :loading="loading"
              >
                {{ $t('orders.sendTooltip') }}
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <!-- history -->
      <div class="row">
        <div class="col-12 px-4">
          <h5>{{ $t('sendNotification.historyTitle') }}</h5>

          <table class="table table-framed">
            <thead>
              <tr>
                <th>{{ $t('columns.createdAt') }}</th>
                <th>{{ $t('columns.title') }}</th>
                <th>{{ $t('sendNotification.bodyLabel') }}</th>
                <th>{{ $t('sendNotification.recipientsLabel') }}</th>
                <th style="width: 50px" />
                <th style="width: 50px" />
              </tr>
            </thead>
            <tbody>
              <tr v-if="history.length === 0">
                <td
                  colspan="6"
                  class="text-xs-center"
                >
                  {{ $t('sendNotification.historyEmptyLabel') }}
                </td>
              </tr>
              <tr
                v-for="item in history"
                :key="item.id"
              >
                <td>{{ item.created_at | moment('YYYY-MM-DD hh:mm A') }}</td>
                <td>{{ item.title }}</td>
                <td>{{ item.body }}</td>
                <td>
                  <span
                    v-if="item.customers && item.customers.length"
                    @click="showHistoryCustomers(item)"
                    style="cursor: pointer; text-decoration: underline;"
                  >{{ audienceLabel(item) }}</span>
                  <span v-else>{{ audienceLabel(item) }}</span>
                </td>
                <td>
                  <div
                    @click="useHistoryItem(item)"
                    :tooltip="$t('sendNotification.useAgainTooltip')"
                    style="cursor: pointer;"
                  >
                    <i
                      style="font-size: 20px;"
                      class="fa fa-reply"
                    ></i>
                  </div>
                </td>
                <td>
                  <div
                    @click="deleteHistoryItem(item)"
                    style="cursor: pointer;"
                  >
                    <i
                      style="font-size: 20px; color: red"
                      class="fa fa-trash"
                    ></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <paginate
            :pagination="pagination"
            :changePage="changePage"
          ></paginate>
        </div>
      </div>

      <v-dialog
        v-model="historyDialog"
        max-width="500px"
      >
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('sendNotification.recipientsLabel') }}</span>
          </v-card-title>
          <v-card-text>
            <table class="table table-framed">
              <thead>
                <tr>
                  <th style="width: 50px">#</th>
                  <th>{{ $t('columns.name') }}</th>
                  <th>{{ $t('columns.phoneNumber') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(c, index) in historyDialogCustomers"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ c.full_name }}</td>
                  <td>{{ c.phone_number }}</td>
                </tr>
              </tbody>
            </table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              flat
              @click="historyDialog = false"
            >
              {{ $t('common.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import swal from 'sweetalert'
import PaginationVue from '../Pagination'

export default {
  components: {
    paginate: PaginationVue
  },

  data() {
    return {
      showSearch: true,
      loading: false,
      customer: {},
      customersList: [],
      selectedCustomers: [],
      history: [],
      historyUrl: 'api/send-notification/history',
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 0,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      },
      historyDialog: false,
      historyDialogCustomers: [],
      form: {
        addall: false,
        delivered_only: false,
        customer_ids: [],
        title: null,
        body: null,
        source_history_id: null
      }
    }
  },

  mounted() {
    this.getCustomers()
    this.getHistory()
  },

  methods: {
    getHistory() {
      let token = localStorage.getItem('access_token')

      Axios
        .get(this.historyUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          const paginator = response.data.data
          this.history = paginator.data
          this.configPagination(paginator)
        })
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },

    changePage(pageUrl) {
      this.historyUrl = pageUrl
      this.getHistory()
    },

    audienceLabel(item) {
      if (item.audience === 'all') return this.$t('sendNotification.audienceAllLabel')
      if (item.audience === 'delivered_only') return this.$t('sendNotification.audienceDeliveredOnlyLabel')

      return `${item.recipients_count} ${this.$t('sendNotification.audienceCustomSuffix')}`
    },

    useHistoryItem(item) {
      this.form.title = item.title
      this.form.body = item.body
      this.form.source_history_id = item.id
      this.form.addall = false
      this.form.delivered_only = false
      this.selectedCustomers = (item.customers || []).map(c => ({ ...c }))
    },

    showHistoryCustomers(item) {
      this.historyDialogCustomers = item.customers || []
      this.historyDialog = true
    },

    deleteHistoryItem(item) {
      swal({
        title: this.$t('common.areYouSure'),
        icon: 'warning',
        buttons: true
      }).then((willDelete) => {
        if (!willDelete) return

        let token = localStorage.getItem('access_token')

        Axios
          .delete(`api/send-notification/history/${item.id}`, { headers: { Authorization: 'Bearer ' + token } })
          .then(() => {
            this.getHistory()
            swal({
              title: this.$t('common.deletedSuccessfully'),
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            })
          })
          .catch((error) => {
            swal(this.$t('common.error'), error.response.data.message, 'error')
          })
      })
    },

    getCustomers() {
      let token = localStorage.getItem('access_token')

      Axios
        .get('api/get-customer-to-select', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.customersList = response.data.data.map((item) => {
            item.text = item.full_name + ' - ' + this.$t('reports.telColonPrefix') + item.phone_number
            item.value = item.user_id

            return item
          })
        })
    },

    customerSelected() {
      if (!this.customer) return

      const found = this.selectedCustomers.find(el => el.user_id === this.customer.user_id)
      if (found) {
        return swal({
          title: '',
          text: this.$t('mobileApp.customerAlreadyInList'),
          icon: 'error',
          timer: 2000,
          buttons: false
        })
      }

      this.selectedCustomers.push({ ...this.customer })
      this.customer = null
      this.showSearch = false
      setTimeout(() => {
        this.showSearch = true
      }, 50)
    },

    removeCustomer(index) {
      this.selectedCustomers.splice(index, 1)
    },

    clearData() {
      this.selectedCustomers = []
      this.customer = null
      this.form = {
        addall: false,
        delivered_only: false,
        customer_ids: [],
        title: null,
        body: null,
        source_history_id: null
      }
    },

    submit() {
      this.form.customer_ids = this.selectedCustomers.map(el => el.user_id)

      if (!this.form.addall && !this.form.delivered_only && this.form.customer_ids.length === 0) {
        return swal({
          title: '',
          text: this.$t('mobileApp.pleaseSelectCustomer'),
          icon: 'error',
          timer: 2000,
          buttons: false
        })
      }

      if (!this.form.title || this.form.title.length === 0) {
        return swal({
          title: '',
          text: this.$t('mobileApp.pleaseEnterTitle'),
          icon: 'error',
          timer: 2000,
          buttons: false
        })
      }

      if (!this.form.body || this.form.body.length === 0) {
        return swal({
          title: '',
          text: this.$t('mobileApp.pleaseEnterBody'),
          icon: 'error',
          timer: 2000,
          buttons: false
        })
      }

      this.loading = true

      let token = localStorage.getItem('access_token')

      Axios
        .post('api/send-notification', this.form, { headers: { Authorization: 'Bearer ' + token } })
        .then(() => {
          this.clearData()
          this.historyUrl = 'api/send-notification/history'
          this.getHistory()
          swal({
            title: this.$t('orders.sentStatusTitle'),
            text: '',
            icon: 'success',
            timer: 1500,
            buttons: false
          })
        }).finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/notification/sendNotification.vue